import React from "react";
import { Card, Typography, Tag, Divider } from "antd";
import GasDocsTable from "../GasDocsTable";
import { gases } from "../../../data";

const { Title, Paragraph, Text } = Typography;

export default function N2OSection() {
  const gas = gases.find((g) => g.key === "n2o");

  return (
    <Card
      bordered
      style={{
        borderRadius: 12,
        padding: 16,
      }}
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Tag
            color={gas.color}
            style={{
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            {gas.icon}
            {gas.label}
          </Tag>
        </span>
      }
    >
      {/* --- Таблица параметров --- */}
      <GasDocsTable gasKey="n2o" />
      <Divider />
      {/* --- 1. Область применения --- */}
      <Paragraph>
        <Text strong>Область применения:</Text> закись азота применяется как
        медицинский сжиженный газ в системах анестезии и анальгезии. Используется
        для ингаляционного наркоза, облегчения родовой боли и хирургических
        операций. Подводка закиси азота предусматривается в операционных,
        наркозных, палатах интенсивной терапии (по заданию на проектирование),
        родовых и предродовых, а также в палатах ожоговых отделений и в
        процедурных ангиографии, эндоскопии, бронхоскопии.
      </Paragraph>

      <Paragraph>
        <Text strong>Нормативная база:</Text> расчёт и проектирование выполняются
        в соответствии с <Text code>СП 158.13330.2014</Text> — «Здания и помещения
        медицинских организаций». Расход определяется по количеству точек,
        коэффициенту использования и времени работы системы.
      </Paragraph>

      <Divider />

      {/* --- 2. Формула расчёта --- */}
      <Paragraph>
        <Text strong>Формула расчёта:</Text>
      </Paragraph>

      <Paragraph
        code
        style={{
          fontSize: 16,
          padding: "8px 12px",
          borderRadius: 6,
          display: "inline-block",
        }}
      >
        {gas.formulaSymbolic}
      </Paragraph>

      <Paragraph type="secondary" style={{ marginTop: 6 }}>
        {gas.formulaText}
      </Paragraph>

      <Divider />

      {/* --- 3. Единицы --- */}
      <Paragraph>
        <Text strong>Единицы измерения:</Text> {gas.unit}
      </Paragraph>

      <Divider />

      {/* --- 4. Особенности расчёта для ИТ --- */}
      <Title level={5}>Особенности расчёта для палат интенсивной терапии</Title>
      <Paragraph>
        Для палат интенсивной терапии и реанимационных залов СП 158.13330.2014
        устанавливает ограничение на максимальный суточный расход закиси азота:
      </Paragraph>
      <ul style={{ marginLeft: 20 }}>
        <li>
          при количестве коек <Text strong>до 12</Text> — общий суточный расход не
          должен превышать круглосуточную потребность{" "}
          <Text strong>трёх коек</Text>;
        </li>
        <li>
          при количестве коек <Text strong>от 12 до 24</Text> — не более
          круглосуточной потребности <Text strong>шести коек</Text>.
        </li>
      </ul>
      <Paragraph type="secondary">
        Данные ограничения учитываются при расчётах суммарного расхода для
        отделений ИТ и применяются как корректирующий лимит.
      </Paragraph>

      <Divider />

      {/* --- 5. Система централизованного снабжения --- */}
      <Title level={5}>Система централизованного снабжения закисью азота</Title>
      <Paragraph>
        Система централизованного снабжения состоит из источника сжиженного газа и
        внутренней сети трубопроводов от источника до точек потребления.
      </Paragraph>

      <Paragraph>
        В медицинских организациях используется только{" "}
        <Text strong>медицинская закись азота (сжиженный газ)</Text>, подающаяся
        к потребителям из централизованного источника.
      </Paragraph>

      <Divider />

      {/* --- 6. Источник снабжения и требования --- */}
      <Title level={5}>Источники снабжения и требования к размещению</Title>
      <Paragraph>
        <ul style={{ marginLeft: 20 }}>
          <li>
            Снабжение осуществляется от <Text strong>двух групп рамп</Text> для{" "}
            <Text strong>10-литровых баллонов</Text> с закисью азота (одна группа —
            рабочая, другая — резервная). При опорожнении рабочей группы
            предусмотрено автоматическое переключение на резервную.
          </li>
          <li>
            Рампы размещаются в помещении управления медицинскими газами — с
            оконными проёмами, на любом этаже, кроме подвала.
          </li>
          <li>
            Баллоны должны устанавливаться не ближе 1 м от отопительных приборов.
            Применяются баллоны ёмкостью 10 л, давлением 6 МПа и выходом
            газообразной закиси ≈ 3000 л.
          </li>
          <li>
            Рабочее давление трубопроводов — до 0.45 МПа. Материалы трубопроводов
            должны обеспечивать герметичность и стойкость к низким температурам
            жидкого газа.
          </li>
        </ul>
      </Paragraph>

      <Divider />

      {/* --- 7. Подключаемые помещения --- */}
      <Title level={5}>Помещения с подводкой закиси азота</Title>
      <Paragraph>
        Операционные, наркозные, процедурные ангиографии, эндоскопии,
        бронхоскопии, родовые и предродовые палаты, ожоговые и палаты интенсивной
        терапии (в том числе детские и для новорождённых).
      </Paragraph>

      <Divider />

      {/* --- 8. Таблица нормативных параметров --- */}
      <Paragraph>
        <Text strong>Нормативные параметры расхода по типам помещений:</Text>
      </Paragraph>

      <GasDocsTable gasKey="n2o" />

      <Paragraph
        type="secondary"
        style={{
          marginTop: 16,
          fontStyle: "italic",
          fontSize: 13,
          lineHeight: 1.6,
        }}
      >
        Нормативы приведены по СП 158.13330.2014. Значения уточняются по
        проектному заданию и могут зависеть от типа анестезиологического
        оборудования, длительности процедур и режима работы операционных и
        наркозных систем.
      </Paragraph>
    </Card>
  );
}
